import { locale, updateLocaleOptions } from "primereact/api";
import { useEffect } from "react";
import { CvpLocale } from "../constants/CvpLocale";
import { LocContext } from "./LocContext";
import { getSourceMap } from "./getSourceMap";
import { getTranslationMap } from "./getTranslationMap";
import { useEvaluatedLocale } from "./useEvaluatedLocale";

export const usePrimeLocale = () => {
  const evaluatedLocale = useEvaluatedLocale();

  const setPrimeLocale = async () => {
    const options =
      evaluatedLocale === CvpLocale.nb
        ? await getSourceMap(LocContext.PRIME, evaluatedLocale)
        : await getTranslationMap(LocContext.PRIME, evaluatedLocale);

    updateLocaleOptions(options, "_custom_primelocale_");

    locale("_custom_primelocale_");
  };

  useEffect(() => {
    setPrimeLocale();
  }, [evaluatedLocale]);
};
